import React from 'react';
import { Link } from 'react-router-dom';
import Cta from '../Common/Cta';
 
class WhyUs extends React.Component {
    render(){
        return (
            <React.Fragment>
                <section className="why-choose-us-two">
                    <div className="row m-0 h-100 align-items-center">
                        <div className="col-lg-4 col-md-6 p-0">
                            <div className="why-choose-img">
                                <img src={require("../../assets/images/Card 1.jpg")} alt="Why Us" />
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 p-0">
                            <div className="why-choose-content">
                                <h3>Exceptional Attention to Detail</h3>
                                <p>Every event is tailored to perfection, ensuring a seamless and personalised experience.</p>
                                {/* <Link to="#">
                                    Know More <i className="icofont-long-arrow-right"></i>
                                </Link> */}

                                <span>01</span>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 p-0">
                            <div className="why-choose-img">
                                <img src={require("../../assets/images/Card 2.jpg")} alt="Why Us" />
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 p-0">
                            <div className="why-choose-content">
                                <h3> Exclusive Partnerships</h3>
                                <p>Collaborations with top venues, travel providers, and entertainers to give you unmatched experiences.</p>
                                {/* <Link to="#">
                                    Know More <i className="icofont-long-arrow-right"></i>
                                </Link> */}

                                <span>02</span>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 p-0">
                            <div className="why-choose-img">
                                <img src={require("../../assets/images/card 3.jpg")} alt="Why Us" />
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 p-0">
                            <div className="why-choose-content">
                                <h3>Innovative Experiences </h3>
                                <p> From virtual tours to themed parties, we go beyond the ordinary to make every moment special.
                                </p>
                                {/* <Link to="#">
                                    Know More <i className="icofont-long-arrow-right"></i>
                                </Link> */}

                                <span>03</span>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <Cta /> */}
            </React.Fragment>
        );
    }
}
 
export default WhyUs;